import React from "react";
import { useNavigate } from "react-router-dom";
import { alumniLeft, alumniRight } from "../../assets";
import AlumniCard from "./AlumniCard";

const Hero = () => {
  const navigate = useNavigate();

  const scrollToWhy = () => {
    const target = document.getElementById("whyus");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const goToPlacement = () => {
    navigate("/PlacementTest");
  };

  return (
    <section className="st-surface-cream overflow-x-clip pb-12 pt-6 sm:pb-16 sm:pt-10 lg:pt-12">
      <div className="mx-auto w-full max-w-6xl px-5 py-10 sm:px-8 lg:px-12 lg:py-12">
        <div className="st-hero-stack grid items-center gap-8 xl:grid-cols-[minmax(180px,220px)_1fr_minmax(180px,220px)]">
          <div className="hidden justify-start xl:flex">
            <AlumniCard
              image={alumniLeft}
              name="Kak Andre"
              university="Aalto University"
              scholarship="Skor IELTS 8.0"
              frameClass="rotate-[-5deg] border-[5px] border-[#F0C84E] translate-y-[35px]"
              topBadgeClass="bg-[#D94D3B] text-white"
              bottomBadgeClass="bg-[#C32017]"
              imageZoom={1.5}
              imagePositionX="70%"
              imageTranslateY="-48px"
            />
          </div>

          <div className="st-text-body text-center">
            <h1
              className="st-font-display mx-auto max-w-3xl text-[38px] leading-[1.08] text-black sm:text-[52px] lg:text-[64px]"
            >
              <span className="md:whitespace-nowrap">A <span className="font-bold">Smarter Way</span> to Boost</span> <br />
              <em>Your</em> <span className="font-bold">IELTS Score</span>
            </h1>

            <p className="st-font-body st-text-body-muted mx-auto mt-6 max-w-2xl text-[20px] leading-relaxed sm:text-[22px]">
              Raih <span className="st-highlight-underlined">IELTS 7</span> dari rumah,
              tanpa les mahal. Program intensif online yang sudah membantu
              <span className="st-highlight-underlined"> 500+</span> pelajar Indonesia lolos
              beasiswa luar negeri.
            </p>

            <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-4">
              <button
                type="button"
                onClick={scrollToWhy}
                className="st-btn-base st-btn-outline st-focus-ring w-full max-w-[220px] px-6 sm:w-auto"
              >
                See How It Works
              </button>

              <button
                type="button"
                onClick={goToPlacement}
                className="st-btn-base st-btn-primary st-focus-ring w-full max-w-[220px] px-8 sm:w-auto"
              >
                Boost My Score
              </button>
            </div>
          </div>

          <div className="hidden justify-end xl:flex">
            <AlumniCard
              image={alumniRight}
              name="Kak Puti"
              university="NTU Singapore"
              scholarship="Skor IELTS 8.0"
              frameClass="rotate-[6deg] border-[5px] border-[#C3301D] translate-y-[35px]"
              topBadgeClass="bg-[#F2B738]"
              bottomBadgeClass="bg-[#DE9C1A]"
              imageZoom={1.5}
              imagePositionX="center"
              imageTranslateY="-60px"
            />
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-end justify-center gap-3 sm:gap-4 xl:hidden">
          <AlumniCard
            image={alumniLeft}
            name="Kak Andre"
            university="Aalto University"
            scholarship="Skor IELTS 8.0"
            frameClass="rotate-[-4deg] border-4 border-[#F0C84E]"
            topBadgeClass="bg-[#D94D3B] text-white"
            bottomBadgeClass="bg-[#C32017]"
            imageZoomMobile={1.50}
            imageZoomTablet={1.60}
            imagePositionXMobile="-18px"
            imagePositionXTablet="-18px"
            imageTranslateYMobile="-32px"
            imageTranslateYTablet="-36px"
          />
          <AlumniCard
            image={alumniRight}
            name="Kak Puti"
            university="NTU Singapore"
            scholarship="Skor IELTS 8.0"
            frameClass="rotate-[4deg] border-4 border-[#C3301D]"
            topBadgeClass="bg-[#F2B738]"
            bottomBadgeClass="bg-[#DE9C1A]"
            imageZoomMobile={1.50}
            imageZoomTablet={1.54}
            imageZoom={1.06}
            imagePositionXMobile="center"
            imagePositionXTablet="center"
            imagePositionX="center"
            imageTranslateYMobile="-44px"
            imageTranslateYTablet="-58px"
            imageTranslateY="28px"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;